import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCapturedTextBoundingBoxEdited.meta';

export type UseTrackCapturedTextBoundingBoxEditedParams = {
  text_id: string;
  text: string;
};

export const useTrackCapturedTextBoundingBoxEdited = () => {
  const { track } = useAnalyticsUtilities();

  const trackCapturedTextBoundingBoxEdited = useCallback(
    (params: UseTrackCapturedTextBoundingBoxEditedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCapturedTextBoundingBoxEdited };
};
